// common
export const PUT_REQUEST = 'appointmentFee/PUT_REQUEST'
export const PUT_SUCCESS = 'appointmentFee/PUT_SUCCESS'
export const PUT_FAILURE = 'appointmentFee/PUT_FAILURE'